import styled from 'styled-components';
import { typography } from 'styles/settings';

export const Container = styled.div`
  ${typography.font.semiBold};
  font-size: ${typography.size.rg};
`;

export const PageInput = styled.input.attrs({
  type: 'number',
  step: 1,
  min: 0,
})`
  ${typography.font.content.semiBold};
  font-size: ${typography.size.rg};
  outline: 0;
  border: none;
  width: 20px;
  text-align: right;
  text-align-last: right;
  background-color: transparent;

  :placeholder {
    opacity: 1;
  }

  :invalid {
    box-shadow: none;
  }

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    margin: 0;
    -webkit-appearance: none;
  }

  -moz-appearance: textfield;
`;
